<div
    style="
            margin-top: 10px;
            display: flex;
            column-gap: 15px;
            justify-content: flex-end;
            font-size: 14px;
    "
>
    <slot />
</div>
